var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.9999 11.1996L1.7999 6.99961L0.399902 8.39961L5.9999 13.9996L17.9999 1.99961L16.5999 0.599609L5.9999 11.1996Z","fill":"#091034"}));
}

CheckInline.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
